<template id="footerPart">
  <section class="footer clearfix">
    <div class="content">
      <div class="clearfix">
        <dl class="pull-left">
          <dt>每日瑜伽</dt>
          <dd>西安瑜乐文化科技股份有限公司</dd>
          <dd>地址：西安市高新区科技三路57号融城云谷B座22层</dd>
          <dd>联系电话：400-990-5662</dd>
          <dd>联系邮箱：support-cn@dailyyoga.com</dd>
          <dd>
            ICP备案号：
            <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"
              >陕ICP备13010109号-1</a
            >
          </dd>
          <!-- <dd>ICP经营许可证编号：
                        <a href="http://www.miitbeian.gov.cn/" target="_blank">陕B2-20170010</a>
          </dd>-->
        </dl>
        <ul class="pull-left">
          <li>
            <router-link
              rel="nofollow"
              class="pull-left"
              :to="{ name: 'aboutUs' }"
              >关于我们</router-link
            >
          </li>
          <!-- <li>
            <router-link
              rel="nofollow"
              class="pull-left"
              :to="{ name: 'honor' }"
              >获奖荣誉</router-link
            >
          </li> -->
          <li>
            <router-link
              rel="nofollow"
              class="pull-left"
              :to="{ name: 'contactUs' }"
              >联系我们</router-link
            >
          </li>
          <li>
            <router-link
              rel="nofollow"
              class="pull-left"
              :to="{ name: 'joinUs' }"
              >加入我们</router-link
            >
          </li>
          <li>
            <!-- <router-link
              rel="nofollow"
              class="pull-left"
              :to="{ name: 'serviceTerms' }"
              >服务条款</router-link
            > -->
            <a href="https://www.dailyyoga.com.cn/cntos_1.html" class="pull-left" target="_blank">用户协议</a>
          </li>
          <li>
            <a href="https://www.dailyyoga.com.cn/privacy.html" class="pull-left" target="_blank">隐私政策</a>
            <!-- <router-link
              rel="nofollow"
              class="pull-left"
              :to="{ name: 'statement' }"
              >隐私声明</router-link
            > -->
          </li>
          <!-- <li>
            <router-link
              rel="nofollow"
              class="pull-left"
              :to="{ name: 'theMedias' }"
              >媒体报道</router-link
            >
          </li> -->
        </ul>
      </div>
      <p class="copy-right">
        www.dailyyoga.com.cn&nbsp;&nbsp;&nbsp;Copyright &copy; 2012-{{ year }}
        &copy; 西安瑜乐文化科技股份有限公司保留所有解释权
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'partFooter',
  beforeCreate() {},
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" type="text/scss"></style>



// WEBPACK FOOTER //
// src/components/partFooter.vue